import { Platform, StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const addEditCustomerGroupsStyle = StyleSheet.create({

    containerView: { flex: 1, backgroundColor: appColors.lightBackgroundColor },
    floatingButtonContainer: { flexDirection: 'row', margin: 10, justifyContent: 'center', alignSelf: 'flex-end', marginBottom: 10 },
    floatingButtonStyle: {borderRadius: 7, width: 100 },
    viewStyle: { backgroundColor: appColors.light, flex: 1, marginHorizontal: 10, padding: 10, borderRadius: 16 },
    labelStyle: { fontSize: fontSize.smallerFontSize, color: appColors.labelColor, },
    errorStyle: { fontSize: fontSize?.errorFontSize, fontFamily: appFonts?.medium, color: appColors?.red, },
    /**
     * 14.6 - the customer list needs a scrolling area of its own.
     *
     * The panel is `flex: 1` inside the form column, so on a browser window
     * the group name, description and validation slots take what they need
     * and the list gets whatever is left - which at common window heights is
     * a handful of pixels, and the list ends up unusable. A minimum height
     * gives it a floor; `overflow: hidden` keeps the FlatList inside the
     * panel scrolling itself instead of pushing the page.
     */
    subViewStyle: {
        borderWidth: 1,
        borderRadius: 8,
        paddingVertical: 10,
        borderColor: appColors.lightGrey,
        ...Platform.select({ web: { minHeight: 360, overflow: 'hidden' as const }, default: {} }),
    },
    headerView: { flexDirection: "row", marginHorizontal: 10, marginTop: 10, },
    filterIconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    saveButtonStyle:{
        marginHorizontal: 18, 
        borderWidth: 1, 
        borderColor: appColors.primary, 
        borderRadius: 7, 
        marginTop: 3
    },
    listContainer: {
        borderRadius: 8,
        backgroundColor: appColors?.light,
        marginVertical: 5,
        padding:10,
        elevation: 1
    },
    filterHeaderStyle: { flexDirection: 'row', marginVertical: 5, justifyContent: 'flex-end' },
    filterContainer: { marginVertical: 10, marginHorizontal: 15, borderRadius: 16 },
    containerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
    },
    /**
     * The label/value pair rows *and* the row that holds the three info
     * columns (14.7).
     *
     * On native this is a plain row, so "Medium: POS" and "Total Spend: 0"
     * each start at the column's left edge and the value lands wherever the
     * label happens to end. Label widths differ by a lot ("Medium: " vs
     * "Customer Type: "), so nothing lines up vertically and the alignment
     * changes from customer to customer as the values change length - which
     * is exactly the "not consistently aligned" report.
     *
     * Pinning the value to the far edge of its column gives every value a
     * fixed x position that depends on neither the label nor the value text,
     * so the columns stay put down the whole list. The same declaration also
     * spreads the three columns evenly instead of bunching them in the left
     * 60% of the card. Web only - the native list keeps its current layout,
     * which suits the narrower phone column.
     */
    flexDirection: {
        flexDirection: 'row' as const,
        ...Platform.select({ web: { justifyContent: 'space-between' as const }, default: {} }),
    },
    /**
     * 10px above every one of the six lines in a row makes each customer
     * card ~60px taller than its content needs, which is why so few rows fit
     * in the list area. Native keeps 10 for touch comfort; a pointer does
     * not need it.
     */
    customerListHeaderText: {
        paddingTop: Platform.OS === 'web' ? 4 : 10,
    }
})